import { createAction } from '@reduxjs/toolkit';

export const setOrderedPartsFilter = createAction('setOrderedPartsFilter');
export const resetOrderedPartsFilter = createAction('resetOrderedPartsFilter');
